export default __webpack_public_path__ + "media/icons/info-yellow-a53c178f.svg";